<h2 mat-dialog-title>Select Judge from the Table</h2>
<mat-dialog-content>
    <mat-table [dataSource]="dataSource" matSort *ngIf="loading === false">
        <ng-container matColumnDef="Select">
            <mat-header-cell *matHeaderCellDef>Select</mat-header-cell>
            <mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="$event ? selection.toggle(row) : null"
                              [checked]="selection.isSelected(row)">
                </mat-checkbox>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="SortableName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.SortableName}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="NomineeTypeName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Nomination</mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.NomineeTypeName}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="JudgingPhase">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Judging Phase</mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.JudgingPhase}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="DistrictNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header>District</mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.DistrictNumber}}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></mat-row>
    </mat-table>

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="OKHandler()" [disabled]="selection.selected.length === 0">Select</button>
    <button mat-raised-button color="warn" (click)="CancelHandler()">Cancel</button>
</mat-dialog-actions>